
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";
import torok from "../../assets/torok.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function TorokMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Török magyar fordító</title>
                <meta name='description' content="Ingyenes török magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Török magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/torok-magyar-fordito" />
            </Helmet>
            <h1>Török magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A török nyelvről</h2>
                    <img src={torok} alt="török zászló"></img>
                </div>

                <p>A török  nyelvet elsősorban Törökországban és Cipruson beszélnek. A világ különböző országaiban élő török közösségek is beszélik. A török gazdag történelméről, egyedi nyelvtanáról, valamint a keleti és nyugati kultúrák közötti híd szerepéről ismert.</p>

                <p>A török írásrendszer a latin ábécét használja ékezetekkel. 29 betűből áll, beleértve a további karaktereket, például ç, ş, ğ, ı és ö. A török kiejtése általában egyszerű, a betűk és a hangok egy az egyben megfelelnek. Minden betűt következetesen ejtenek ki, így viszonylag könnyű megtanulni a török szavak kiejtését.</p>

                <p>Nyelvtanának jellemzője az agglutináció, ahol a gyökérszavakhoz toldalékokat adnak, amelyek jelzik az igeidőt, a módot, az aspektust és más nyelvtani jellemzőket. Ez lehetővé teszi hosszú, pontos jelentésű szavak létrehozását. A főnevek és melléknevek esetszám, szám és birtoklás esetén is elutasításra kerülnek. Az igék ragozása idő, mód, személy és szám szerint történik.</p>

                <p>A török szókincs török eredetű, de többek között arab, perzsa, francia és angol kölcsönszavakat is tartalmaz. A török irodalom gazdag hagyományokkal rendelkezik, olyan befolyásos költőkkel és írókkal, mint Yunus Emre, Ahmet Hamdi Tanpınar és Orhan Pamuk. A török kultúra különféle hatások keveréke, amely tükrözi történelmi és földrajzi kapcsolatait.</p>

                <p>A török nyelvtudás számos lehetőséget kínál. Törökország gazdasága dinamikus, különösen az olyan ágazatokban, mint a turizmus, a gyártás, a pénzügy és a technológia. A török nyelv ismerete előnyös lehet ezeken a területeken végzett karrierhez, vagy azoknak, akik érdeklődnek a törökországi tanulás vagy munka iránt.</p>

                <p>A török nyelv ismerete megkönnyíti a kommunikációt és a kulturális elmélyülést is a török nyelvű közösségekben. Lehetővé teszi a török szokások, hagyományok és társadalmi normák mélyebb megértését. A török vendégszeretet, a hagyományos művészetek, a zene és a konyha a török kultúra gazdagságát mutatják be.</p>

                <p>Ezenkívül a török nyelv tanulása hozzáférést biztosít Törökország kulturális örökségéhez és történelmi jelentőségéhez. Lehetővé teszi az ország ősi civilizációinak, építészeti csodáinak és természeti csodáinak jobb értékelését. Törökország stratégiai elhelyezkedése Európa és Ázsia metszéspontján alakította sokszínű kulturális identitását.</p>


                <div className="sectionbottom">
                    <Link to="/magyar-torok-fordito">Magyar török fordító</Link>

                    <img src={torok} alt="török zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>
            </section>
        </>

    )
}

export default TorokMagyar;